import React from 'react'
import styled from 'styled-components'

import { onNavigateExternalEvent } from 'analytics/performance'
import { ButtonContent } from 'components/styled/button/button-content'
import {
  BaseButtonProps,
  BaseButtonStyle,
  BaseButtonStyleProps,
  ButtonBox,
} from './base-button'

export interface ExternalLinkProps extends BaseButtonProps {
  href: string
  target?: '_blank' | '_self' | '_parent' | '_top'
}

export const StyledButtonExternalLink = styled.a<BaseButtonStyleProps>`
  ${BaseButtonStyle};

  &:hover,
  &:active,
  &:focus,
  &:visited {
    outline: none;
  }
`

export const ExternalLinkButton = ({
  loading = false,
  event,
  variant = 'primary',
  icon,
  useOutlinedIcon,
  svgIcon,
  text,
  size = 'default',
  label,
  href,
  target,
  ...props
}: ExternalLinkProps) => {
  const onLinkClick = () => {
    if (event) onNavigateExternalEvent(event)
  }

  return (
    <ButtonBox {...props}>
      <StyledButtonExternalLink
        $variant={variant}
        $size={size}
        $hasText={!!text}
        $loading={!!loading}
        aria-label={label}
        /* External link specific props */
        tabIndex={0}
        onClick={onLinkClick}
        href={href}
        target={target}
      >
        <ButtonContent
          variant={variant}
          icon={icon}
          useOutlinedIcon={useOutlinedIcon}
          svgIcon={svgIcon}
          text={text}
          loading={loading}
          size={size}
        />
      </StyledButtonExternalLink>
    </ButtonBox>
  )
}
